import { Component, OnInit, Input, ViewChild, ElementRef, Injector, ComponentFactoryResolver, HostBinding, Output, EventEmitter, TemplateRef, ViewContainerRef, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { ProcessTime } from './model/process-time';
import { ProcessDesignerUIState } from './app/process-designer.uistate';
import { FlowFormInfo } from './domain/entities/flowform-info';
import { ProcessDesignerViewModel } from './app/process-designer.viewmodel';
import { BizComponentEntity } from './domain/entities/biz-component.entity';
import { ExecuteFormModel, TerminalType } from './views/execute-forms/entities/execute-form.entity';
import { ExcuteFormEntity } from './domain/entities/excute-form.entity';
import { ModalOptions, BsModalService } from '@farris/ui-modal';
import { BackWardRule } from './views/backward-rule/backward-rule.entity';
import { ProcessDesignerDataService } from './domain/process-designer.dataservice';
import { LoadingService } from '@farris/ui-loading';
import { NotifyService, NotifyOptions } from '@farris/ui-notify';
import { MessagerService } from '@farris/ui-messager';
import { WFFlowElementsViewModel } from './app/wf-flowElements.viewModel';
import { HttpErrorResponse } from '@angular/common/http';
import { PropertyPanelComponent, ShowMode } from '@farris/ide-property-panel';
import { SignRuleComponent } from './views/sign-rule/sign-rule.component';
import { ProcessInfo } from './model/process-info';
import { RTProcessInfo } from './model/rt-process-info';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { AuditEvent } from './domain/entities/audit-processDef-info';
import { NoteComponent } from './views/note/note.component';
import { ProcessDeUtil } from './domain/process-de-util';
import { FlowFormEntity } from './domain/entities/flowform.entity';
import { EventBusService } from './views/shared/event-bus.service';
import { VerifyDetailService } from '@farris/ui-verify-detail';
import { AssignScopeComponent } from './views/assign-scope/assign-scope.component';
import { WfEditorUi } from './designer/WfEditorUi';
import { PmfEvents, Cell } from "@edp-pmf/grapheditor";
import { BpmnModel } from "@edp-pmf/bpmn-model";
import { MxGraphNS, mxEvent } from "@edp-pmf/mxgraph-ts";
import { WfValidatorAdapter } from "./designer/WfValidatorAdapter";
import { ProcessHeader, StartMode } from "@gsp-wf/wf-process-model";
import { EventBusKeys } from './model/event-bus-keys';
import { ProcessPropertyKeys } from './designer/wf-cell/property-keys/ProcessPropertyKeys';
import { UserActivityPropertyKeys } from './designer/wf-cell/property-keys/UserActivityPropertyKeys';
import { MessageActivityPropertyKeys } from './designer/wf-cell/property-keys/MessageActivityPropertyKeys';
import { StartActivityPropertyKeys } from './designer/wf-cell/property-keys/StartActivityPropertyKeys';
import { NotifyActivityPropertyKeys } from './designer/wf-cell/property-keys/NotifyActivityPropertyKeys';
import { delay, switchMap } from 'rxjs/operators';
import { WF_LANG_RESOURCES, WfLocalePipe } from './i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from './i18n/assets/lang.resource';
import { BatchSetPropertiesComponent } from './views/batch-set-properties/batch-set-properties.component';
import { MonacoEditorComponent } from './views/ng-monaco-editor/components/monaco-editor/monaco-editor.component';
import { SaveAsEditComponent } from './views/save-as-edit/save-as-edit.component';
import { TitleExpressionComponent } from './views/title-expression/title-expression.component';
import { ExecuteFormsComponent } from './views/execute-forms/execute-forms.component';
import { EditComponentParameterComponent } from './views/edit-component-parameter/edit-component-parameter.component';
import { TimeLimitControlComponent } from './views/time-limit-control/time-limit-control.component';

@Component({
  selector: 'wf-process-editor',
  templateUrl: './wf-process-editor.component.html',
  styles: [`
    .bpmn-designer {
      height: 100%;
      min-height: 400px;
      width: 100%;
    }`
  ],
  providers: [
    { provide: WF_LANG_RESOURCES, useValue: WF_PROCESS_EDITOR_LANG_RESOURCES },
    WfLocalePipe,
  ]
})

export class WfProcessEditorComponent implements OnInit {
  private flag = true;

  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  private _time: ProcessTime;
  @Input()
  set time(t: ProcessTime) {
    this._time = t;
    this.uiState.time = t;
  }
  get time(): ProcessTime {
    return this._time;
  }

  @Input()
  processInfo: ProcessInfo;

  @Input()
  rtProcessInfo: RTProcessInfo;

  @Input()
  action: 'view' | 'edit' | 'assignView' = 'edit';

  @Input()
  mode: 'general' | 'simplify' = 'general';

  @Input()
  set scene(v: string) {
    this.uiState.scene = v;
  }
  get scene() {
    return this.uiState.scene;
  }

  @Input()
  procType: "wf" | "whole" = "wf";

  @Input()
  content: string;

  @Input()
  oldBizDefKey: string;

  /**
 * 界面是否发生变化标志，修改属性、移动节点等均会将此值设为true
 */
  changedFlag = false;

  @Input() 
  set isChangedFlag(v: string) {
    if(v && v === 'true'){
      this.changedFlag = true;
    }else {
      this.changedFlag = false;
    }
  }

  @Input()
  set isByRoute(v: string) {
    if(v && v === 'true'){
      this.uiState.isByRoute = true;
      this.changedFlag = true;
    }else {
      this.uiState.isByRoute = false;
    }
  }
  get isByRoute() {
    return this.uiState.isByRoute + '';
  }

  @Output() close = new EventEmitter<any>();

  @Output() outProc = new EventEmitter<any>();

  @ViewChild('propertyPanel')
  propertyPanel: PropertyPanelComponent;
  @ViewChild('tipsTmpl')
  tipsTmpl: TemplateRef<any>;
  @ViewChild('iframe')
  iframe: ElementRef;
  errorList = [];
  tabTypeList = [
    {
      id: 'processWarning',
      type: 'processWarning',
      title: this.localePipe.instant("processEditor.tip"),
      iconCls: 'f-icon-default',
      iconStyle: 'color:#f49730;'
    }
  ];
  @ViewChild('content') contentEl;
  verifyContainer;
  listclick;
  showchange;
  panelWidth = 330;
  propertyPanelResizable = true;
  rightPanelWidth = 330; // 右侧面板宽度
  clientWidth: number; // 界面总宽度
  widthAfterResized: number; // 用户调整后的宽度（比例，如0.3）
  private verifySer: VerifyDetailService;
  procNameTitle: string;
  @ViewChild("editorUiContainer")
  editorUiContainerER: ElementRef<HTMLDivElement>;
  @ViewChild("editorUiContainer", { read: ViewContainerRef })
  editorUiContainerVCR: ElementRef<HTMLDivElement>;
  editorUi: WfEditorUi;
  // localeId: string = "zh-CHS";
  //事件监听
  keydownHandler;

  //表示当前是否已经有弹出关闭确认的弹框
  isShowCloseDialog = false;

  constructor(
    public uiState: ProcessDesignerUIState,
    private viewModel: ProcessDesignerViewModel,
    public service: ProcessDesignerDataService,
    private loadService: LoadingService,
    private notify: NotifyService,
    private message: MessagerService,
    private activity: WFFlowElementsViewModel,
    private injector: Injector,
    private modalService: BsModalService,
    private resolver: ComponentFactoryResolver,
    private eventBus: EventBusService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.cdr = this.cdr || this.injector.get(ChangeDetectorRef, null);
    this.verifySer = this.injector.get(VerifyDetailService);
    this.localeId = this.injector.get(LOCALE_ID, null) || this.localeId;
    WfValidatorAdapter.localePipe = this.localePipe;
    this.clearValidationTips();
    forkJoin(this.uiState.getEnableAdminOrgAut(), this.uiState.getEnableFlowFormAut()).subscribe(re => {
      this.uiState.enableAdminOrgAut = re[0];
      this.uiState.enableFlowFormAut = re[1];
      if (!this.uiState.enableAdminOrgAut) {
        this.uiState.getAdministratorInfo();
      }
    });
  }
  showModelButton = false;
  ngOnInit() {
    this.procNameTitle = this.processInfo ? (this.processInfo.processNameLanguage ? this.processInfo.processNameLanguage[localStorage.getItem("languageCode")] : this.processInfo.processName) : this.rtProcessInfo.procName;
    if (this.rtProcessInfo && this.rtProcessInfo.rtProcDefId) {
      this.uiState.procDefId = this.rtProcessInfo.rtProcDefId;
    }
    this.addEventBusListener();
    this.uiState.initUIState();
    this.showLoading();
    this.addPropertyChangedHandler();
    // 获取消息列表
    this.uiState.getMessageChannels();
    focus();
    this.keydownHandler = this.viewModelMethod.bind(this);
    document.body.addEventListener('keydown', this.keydownHandler);

    this.cdr && this.cdr.detectChanges();
    this.createEditorUi();
    if(this.oldBizDefKey) {
      this.uiState.isSaved = false;
    }else {
      this.uiState.isSaved = true;
    }
    // if(this.uiState.isByRoute) {
    //   this.changedFlag = true;
    // }else {
    //   this.changedFlag = false;
    // }
  }

  createEditorUi() {
    this.service.getGeneralConfig().subscribe(
      (generalConfig) => {
        const processCategoryId: string = this._time === ProcessTime.rt ? this.rtProcessInfo.flowFormId : this.processInfo.flowFormId;
        this.viewModel.getProcessCategory(processCategoryId).subscribe(
          (procCategory: FlowFormEntity) => {
            if(!procCategory) {
              this.notify.error(this.localePipe.instant("processEditor.checkProcessCategoryExist"));
            }
            const bizCategoryId = this._time === ProcessTime.dt ? procCategory.businessObjectId : undefined;
            this.service.getFormFormat(bizCategoryId).pipe(
              switchMap(
                (formFormats) => {
                  this.cdr && this.cdr.detectChanges();
                  this.editorUi = new WfEditorUi(this._time, this.action, this.editorUiContainerER.nativeElement,
                    this.injector, this.modalService, this.resolver);
                  this.editorUi.multiLangEnabled = true;
                  this.editorUi.langCode = this.localeId;
                  this.editorUi.bizCategoryId = bizCategoryId;
                  this.editorUi.mode = this.mode;
                  this.editorUi.scene = this.uiState.scene;
                  this.editorUi.procType = this.procType;
                  this.editorUi.generalConfig = generalConfig;
                  this.editorUi.formFormats = formFormats;
                  this.editorUi.uistate = this.uiState;
                  return of({});
                }
              )
            )
              // 2023-5-30 为了解决网络较差场景下的加载问题修改了加载顺序
              .pipe(delay(200))
              .subscribe(() => {
                this.openProcContent();
              });
          }
        );
      }
    );
  }

  addEditorUiListeners(editorUi: WfEditorUi) {
    editorUi.addListener(PmfEvents.ShowProperty, (sender, evt: MxGraphNS.mxEventObject) => {
      const cells: Cell[] = evt.getProperty("cells");
      this.viewModel.setProperty(this.editorUi.getFarrisPropConfig(cells));
    });
    // 工具箱节点拖动至画布后更新
    editorUi.graph.addListener(PmfEvents.CellsInserted, (sender, evt: MxGraphNS.mxEventObject) => {
      this.uiState.getUserActList(this.editorUi.getActivities());
      this.uiState.getNotifyEventList(this.editorUi.getNotifyEvents());
      this.uiState.getEndEventList(this.editorUi.getEndEvents());
    });
    // 删除节点时触发更新
    editorUi.graph.addListener(mxEvent.CELLS_REMOVED, () => {
      this.uiState.getUserActList(this.editorUi.getActivities());
      this.uiState.getNotifyEventList(this.editorUi.getNotifyEvents());
      this.uiState.getEndEventList(this.editorUi.getEndEvents());
    });
  }

  /**
   * 添加事件总线监听
   */
  private addEventBusListener() {
    this.eventBus.on(EventBusKeys.batchCopyProperty, data => {
      if (data) {
        this.editorUi.batchCopyProperty(data);
      }
    });
    this.eventBus.on(EventBusKeys.batchSetProperty, data => {
      if (data) {
        this.editorUi.batchSetProperty(data);
      }
    });
  }

  private addPropertyChangedHandler(): boolean {
    this.propertyPanel.propertyChanged.subscribe((data: any) => {
      this.updateChangeProperty(data);
    });
    this.propertyPanel.submitModal.subscribe((data: any) => {
      this.updateChangeProperty(data.changeObject, data.parameters);
    });

    return false; // 防止冒泡
  }

  /**
   * 更新属性
   */
  private updateChangeProperty(data, parameters = null): any {
    // 更新界面变更状态
    this.changedFlag = true;

    data.Id = this.uiState.propertyData.Id;
    if (parameters) {
      data.parameters = parameters;
    }
    switch (data.propertyID) {
      case ProcessPropertyKeys.EntryForm:
        this.bindEntryFormInfo(data);
        break;
      case UserActivityPropertyKeys.ApprovalItems:
        this.editorUi.updateProperty(data);
        this.activity.buildCounterSignVariables(data.propertyValue);
        break;
      case UserActivityPropertyKeys.CompleteStrategy:
        this.beforeCompleteStrategyChange(data).subscribe(b => {
          if (b) {
            this.editorUi.updateProperty(data);
            this.completeStrategyChanged(data.propertyValue);
          }
          this.viewModel.setProperty(this.editorUi.refreshProperty(data));
        });
        break;
      // todo：多个活动具有同名属性时，如何更合理定义PropertyKey？
      // case UserActivityPropertyKeys.otherAssignNodes:
      // case StartActivityPropertyKeys.otherAssignNodes:
      //   if (data.propertyValue) {
      //     this.editorUi.updateProperty(data);
      //     this.OtherAssignNodesChanged(data);
      //   } else {
      //     this.editorUi.updateProperty(data);
      //   }
      //   break;
      case UserActivityPropertyKeys.SignRule:
        this.editorUi.updateProperty(data);
        break;
      // todo：多个活动具有同名属性时，如何更合理定义PropertyKey？
      case ProcessPropertyKeys.messageNotice: // 消息通知
      case UserActivityPropertyKeys.messageNotice: // 消息通知
      case MessageActivityPropertyKeys.messageNotice: // 消息通知
      case NotifyActivityPropertyKeys.messageNotice: // 消息通知
        if (data.propertyValue.isBatchCopy) { // 是否是消息通知属性批量复制
          this.editorUi.batchCopyProperty(data);
          break;
        }
        this.editorUi.updateProperty(data);
        break;
      case ProcessPropertyKeys.startMode:
        this.updateStartMode(data);
        break;
      default:
        this.editorUi.updateProperty(data);
        break;
    }
    this.uiState.getUserActList(this.editorUi.getActivities());
    this.uiState.getEndEventList(this.editorUi.getEndEvents());
    this.uiState.getNotifyEventList(this.editorUi.getNotifyEvents());
    this.uiState.getStartMode(this.editorUi.getStartMode());
    if (this.editorUi.getStartMode() == StartMode.SUB_PROCESS) {
      this.uiState.subActivityContext = this.uiState.subActivityContext.concat(this.uiState.subProcessElementContext);
    } else {
      this.uiState.subActivityContext = this.uiState.subActivityContext.filter(x => this.uiState.subProcessElementContext.some(y => y.key != x.key))
    }
    this.viewModel.setProperty(this.editorUi.refreshProperty(data));
  }

  /**
   * 绑定流程分类的参数列表，流程构件，表单赋值
   * @param data
   */
  private bindEntryFormInfo(data) {
    const flowformId: string = data.propertyValue.id;
    if (flowformId) {
      this.viewModel.getFlowFormInfoById(flowformId).subscribe((info: FlowFormInfo) => {
        data.flowForm = info.flowForm;
        data.formalParameters = info.formalParameters;
        data.processBizComponnets = info.bizComponents;
        data.executeForms = [];
        info.excuteForms.forEach(form => {
          if (form.isDefault) {
            // 流程绑定默认单据
            const executeForms = this.ConvertExecuteForm(form);
            data.executeForms = data.executeForms.concat(executeForms);
          }
        });
        data.customizeActions = info.customizeActions.filter(a => a.isAll === true).map(a => ({
          id: a.id, code: a.code, name: a.name, terminalType: a.terminal,
          actualParameters: a.actualParameters.map(p => ({
            Name: p.code, Value: p.value, ValueText: p.name, Tag: 'expression'
          }))
        }));
        // 加载业务活动面板
        this.editorUi.loadBizActivities(info.bizActivities || []);
        this.service.getBizCmp().subscribe((cmps) => {
          data.bizCmps = cmps;
          this.editorUi.updateProperty(data);

          this.uiState.getUserActList(this.editorUi.getActivities());
          this.uiState.getEndEventList(this.editorUi.getEndEvents());
          this.uiState.getNotifyEventList(this.editorUi.getNotifyEvents());
          this.uiState.getStartMode(this.editorUi.getStartMode());
          if (this.editorUi.getStartMode() == StartMode.SUB_PROCESS) {
            this.uiState.subActivityContext = this.uiState.subActivityContext.concat(this.uiState.subProcessElementContext);
          } else {
            this.uiState.subActivityContext = this.uiState.subActivityContext.filter(x => this.uiState.subProcessElementContext.some(y => y.key != x.key))
          }
          this.viewModel.setProperty(this.editorUi.refreshProperty(data));
        });
      });
    }
  }

  updateStartMode(data: any) {
    const bpmnModel = this.editorUi.graph.bpmnModel;
    const extendElements = bpmnModel.DefaultProcess.GetExtensionElements();
    if (extendElements !== null && extendElements.length > 0) {
      const procHeader = extendElements.filter(e => e instanceof ProcessHeader) as ProcessHeader[];
      let flowFormKey = procHeader[0].BizDefKey;
      this.service.getAllBizCmp(flowFormKey).subscribe((allBizCmps) => {
        this.service.getBizCmp().subscribe((bizCmps) => {
          data.allBizCmps = allBizCmps;
          data.bizCmps = bizCmps;

          this.editorUi.updateProperty(data);

          this.uiState.getUserActList(this.editorUi.getActivities());
          this.uiState.getEndEventList(this.editorUi.getEndEvents());
          this.uiState.getStartMode(this.editorUi.getStartMode());
          if (this.editorUi.getStartMode() == StartMode.SUB_PROCESS) {
            this.uiState.subActivityContext = this.uiState.subActivityContext.concat(this.uiState.subProcessElementContext);
          } else {
            this.uiState.subActivityContext = this.uiState.subActivityContext.filter(x => this.uiState.subProcessElementContext.some(y => y.key != x.key))
          }
          this.viewModel.setProperty(this.editorUi.refreshProperty(data));
        });
      });
    }
  }

  private note(record: string) {
    const compFactory = this.resolver.resolveComponentFactory(NoteComponent);
    const compRef = compFactory.create(this.injector);

    compRef.instance.record = record;

    const modalConfig: ModalOptions = {
      title: this.localePipe.transform("processEditor.changeRecord"),
      width: 800,
      height: 520,
      showButtons: true,
      buttons: compRef.instance.footer
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.cancel.subscribe($event => dialog.close());
    compRef.instance.submit.subscribe((data: string) => {
      // 更新流程记录
      this.editorUi.graph.bpmnModel.DefaultProcess.Documentation = data;
      dialog.close();
    });
  }

  private openProcContent() {
    if (this.time === ProcessTime.dt) {
      if (this.processInfo) {
        if(this.content) {
          this.viewModel.getFlowFormInfoById(this.processInfo.flowFormId).subscribe((info: FlowFormInfo) => {
            // this.editorUi.loadBizActivities(info.bizActivities || []);
            this.uiState.content = this.checkModelContent(this.content);
            this.openProcess(this.uiState.content, info.bizActivities);
          });
        }else if (this.processInfo.processKey === EventBusKeys.new && this.processInfo.flowFormId) {
          this.openNewProcess(this.processInfo.flowFormId);
        } else {
          // TODO：首先获取流程分类信息，确保流程分类和流程构件获取到（会稍微影响设计器打开速度）
          this.viewModel.getFlowFormInfoById(this.processInfo.flowFormId).subscribe((info: FlowFormInfo) => {
            // this.editorUi.loadBizActivities(info.bizActivities || []);
            this.getProcContent(this.processInfo.processKey).subscribe(re => {
              this.uiState.content = this.checkModelContent(JSON.stringify(re));
              this.openProcess(this.uiState.content, info.bizActivities);
            }, error => {
              this.notify.error(this.localePipe.instant("processEditor.processIsExist"));
            });
          });
        }
      } else {
        throw new Error(this.localePipe.transform("processEditor.noDtInfo"));
      }
    } else if (this.time === ProcessTime.rt) {
      if (this.rtProcessInfo) {
        this.viewModel.getFlowFormInfoById(this.rtProcessInfo.flowFormId).subscribe((info: FlowFormInfo) => {
          // this.editorUi.loadBizActivities(info.bizActivities || []);
          this.getProcContent(this.rtProcessInfo.rtProcDefId).subscribe(re => {
            this.uiState.content = this.checkModelContent(JSON.stringify(re));
            this.openProcess(this.uiState.content, info.bizActivities);
          });
        });
      } else {
        throw new Error(this.localePipe.transform("processEditor.noRtInfo"));
      }
    }
  }

  /**
   * 新增流程，基于流程分类获取参数列表，构件和表单
   * @param ffId 流程分类ID
   */
  openNewProcess(ffId: string) {
    this.viewModel.getFlowFormInfoById(ffId).subscribe(
      (info: FlowFormInfo) => {
        const processBizComponnets: BizComponentEntity[] = info.bizComponents;
        const customizeActions = info.customizeActions.filter(a => a.isAll === true).map(a => ({
          id: a.id, code: a.code, name: a.name, terminalType: a.terminal,
          actualParameters: a.actualParameters.map(p => ({
            Name: p.code, Value: p.value, ValueText: p.name, Tag: 'expression'
          }))
        }));
        let executeForms: ExecuteFormModel[] = [];
        info.excuteForms.forEach(form => {
          if (form.isDefault) {
            // 流程绑定默认单据
            const forms = this.ConvertExecuteForm(form);
            executeForms = executeForms.concat(forms);
          }
        });
        // 如果不存在表单定义，需要去表单格式列表取一下
        if (executeForms.length === 0
          || executeForms.findIndex(e => e.TerminalType === TerminalType.PC) === -1
          || executeForms.findIndex(e => e.TerminalType === TerminalType.MOBILE) === -1) {
          this.viewModel.getFormFormatsByBizCategory().subscribe(
            (formFormats: any[]) => {
              if (formFormats && formFormats.length > 0) {
                if (executeForms.findIndex(e => e.TerminalType === TerminalType.PC) === -1) {
                  const formFormat = formFormats.filter(f => f.terminal === 'PC' && f.status === 0)[0];
                  if (formFormat) {
                    executeForms.push(this.formFormat2ExecuteForm(formFormat));
                  }
                }
                if (executeForms.findIndex(e => e.TerminalType === TerminalType.MOBILE) === -1) {
                  const formFormat = formFormats.filter(f => f.terminal === 'Mobile' && f.status === 0)[0];
                  if (formFormat) {
                    executeForms.push(this.formFormat2ExecuteForm(formFormat));
                  }
                }
              }
              const newProcInfo = {
                name: this.processInfo.processName,
                nameLanguage: this.processInfo.processNameLanguage,
                bizObjId: this.processInfo.bizObjId,
                ffId: ffId,
                ffName: this.processInfo.flowFormName,
                startMode: this.processInfo.startMode,
                formalParameters: info.formalParameters,
                processBizComponnets: processBizComponnets,
                executeForms: executeForms,
                customizeActions: customizeActions,
                processDescription: info.flowForm.processDescription,
              };
              this.createBpmnModel(info.bizActivities || [], newProcInfo);
            }
          );
        } else {
          const newProcInfo = {
            name: this.processInfo.processName,
            nameLanguage: this.processInfo.processNameLanguage,
            bizObjId: this.processInfo.bizObjId,
            ffId: ffId,
            ffName: this.processInfo.flowFormName,
            startMode: this.processInfo.startMode,
            formalParameters: info.formalParameters,
            processBizComponnets: processBizComponnets,
            executeForms: executeForms,
            customizeActions: customizeActions,
            processDescription: info.flowForm.processDescription,
          };
          this.createBpmnModel(info.bizActivities || [], newProcInfo);
        }
      }
    );
  }

  createBpmnModel(bizActivities, newProcInfo) {
    this.service.getBizCmp().subscribe(
      (cmps: any) => {
        // 2023-5-30 为了解决网络较差场景下的加载问题修改了加载顺序 先加载数据再showeditorUi
        this.editorUi.show();
        this.addEditorUiListeners(this.editorUi);
        this.editorUi.loadBizActivities(bizActivities || []);
        this.editorUi.createBpmnModel(newProcInfo, cmps);

        this.service.getProcExtendProperty(newProcInfo.BizDefKey, newProcInfo.startMode, this.editorUi.bizCategoryId).subscribe(
          (property: any) => {
            const props = [];
            property.forEach(p => {
              if ((p.bizCategoryId || p.bizDefKey) && ((p.bizCategoryId.indexOf(this.editorUi.bizCategoryId) != -1 || p.bizCategoryId === '*') ||
                (p.bizDefKey.indexOf(newProcInfo.BizDefKey) != -1 || p.bizDefKey === '*')) &&
                (p.startMode.indexOf(newProcInfo.startMode) != -1 || p.startMode === '*')) {
                props.push(p);
              }
            });
            this.editorUi.procExtProps = props;


            if (this.flag) {
              this.flag = false;
              this.closeLoading();
            }
            // 显示流程属性
            this.viewModel.initProcessProperty(this.editorUi.getFarrisPropConfig());
            // 获取启动方式
            this.uiState.getStartMode(this.editorUi.getStartMode());
            if (this.editorUi.getStartMode() == StartMode.SUB_PROCESS) {
              this.uiState.subActivityContext = this.uiState.subActivityContext.concat(this.uiState.subProcessElementContext);
            } else {
              this.uiState.subActivityContext = this.uiState.subActivityContext.filter(x => this.uiState.subProcessElementContext.some(y => y.key != x.key))
            }
            this.uiState.bpmnModel = this.editorUi.graph.bpmnModel;

            this.addGraphModelChangedListener();
          }
        );
      }
    );
  }

  /**
   * 
   * @param content 流程模型
   * @param bizActivities 业务活动
   * @param saveAs 是否是打开另存为后的界面
   */
  openProcess(content: string, bizActivities?) {
    // 取ProcessHeader
    const model = new BpmnModel();
    model.LoadFromJson(content);
    if(this.processInfo ? this.processInfo.processName : this.rtProcessInfo.procName) {
      if(model.DefaultProcess.NameLanguage && model.DefaultProcess.NameLanguage[this.localePipe.langCode]) {
        this.procNameTitle = model.DefaultProcess.NameLanguage[this.localePipe.langCode];
      }
    }
    const processHeader = (model.DefaultProcess.GetExtensionElements().filter(e => (e instanceof ProcessHeader))[0] as ProcessHeader);
    this.service.getProcExtendProperty(processHeader.BizDefKey, processHeader.startMode, this.editorUi.bizCategoryId).subscribe(
      (property: any) => {
        const props = [];
        property.forEach(p => {
          if ((p.bizCategoryId || p.bizDefKey) && ((p.bizCategoryId.indexOf(this.editorUi.bizCategoryId) != -1 || p.bizCategoryId === '*') ||
            (p.bizDefKey.indexOf(processHeader.BizDefKey) != -1 || p.bizDefKey === '*')) &&
            (p.startMode.indexOf(processHeader.startMode) != -1 || p.startMode === '*')) {
            props.push(p);
          }
        });
        this.editorUi.procExtProps = props;
        // 2023-5-30 为了解决网络较差场景下的加载问题修改了加载顺序 先加载数据再showeditorUi
        this.editorUi.show();
        this.addEditorUiListeners(this.editorUi);
        this.editorUi.loadBizActivities(bizActivities || []);
        this.editorUi.openBpmnModel(content);


        if (this.flag) {
          this.flag = false;
          this.closeLoading();
        }
        // 显示流程属性
        this.viewModel.initProcessProperty(this.editorUi.getFarrisPropConfig());
        // 打开时获取所有活动节点信息
        this.uiState.getUserActList(this.editorUi.getActivities());
        // 打开时获取所有结束节点信息
        this.uiState.getEndEventList(this.editorUi.getEndEvents());
        // 打开时获取所有知会节点信息
        this.uiState.getNotifyEventList(this.editorUi.getNotifyEvents());
        // 打开时获取所有消息节点信息
        this.uiState.getMessageEventList(this.editorUi.getMessageEvents());
        // 打开时获取所有子流程和信号捕获节点信息
        this.uiState.getSubAndCatchEventsList(this.editorUi.getSubAndCatchEvents());

        this.uiState.bpmnModel = this.editorUi.graph.bpmnModel;

        // 获取启动方式
        this.uiState.getStartMode(this.editorUi.getStartMode());
        if (this.editorUi.getStartMode() == StartMode.SUB_PROCESS) {
          this.uiState.subActivityContext = this.uiState.subActivityContext.concat(this.uiState.subProcessElementContext);
        } else {
          this.uiState.subActivityContext = this.uiState.subActivityContext.filter(x => this.uiState.subProcessElementContext.some(y => y.key != x.key))
        }

        this.addGraphModelChangedListener();
      }
    );
  }

  /**
   * 添加graph model监听器，有变化则将changedFlag
   */
  addGraphModelChangedListener() {
    // 监听画布变化，更新界面变更状态
    const changedListener = () => {
      this.changedFlag = true;
    }
    this.editorUi.graph.model.addListener(mxEvent.CHANGE, changedListener);
  }

  private showTip(data: any) {
    if (data.type === 'message') {
      switch (data.level) {
        case 'warning':
          this.message.warning(data.message);
          break;
        case 'error':
          this.message.error(data.message);
          break;
        case 'question':
          this.message.question(data.message, () => {
            this.questionOKHandle(data);
          });
          break;
        default:
          this.message.info(data.message);
          break;
      }
    } else if (data.type === 'notify') {
      switch (data.level) {
        case 'warning':
          this.notify.warning(data.message);
          break;
        case 'error':
          this.notify.error(data.message);
          break;
        default:
          this.notify.info(data.message);
          break;
      }
    }
  }

  private showVerify(data: any) {
    this.errorList = data;
    this.createValidationTips();
  }

  private questionOKHandle(data: any) {
    switch (data.action) {
    }
  }

  /**
   * 获取流程上下文
   * @param id 流程定义ID（设计时使用流程定义Key，运行时使用流程定义ID）
   */
  getProcContent(id: string): Observable<any> {
    if (id) {
      if (this.time === ProcessTime.dt) {
        return this.service.getProcContentbyKey(id);
      } else if (this.time === ProcessTime.rt) {
        return this.service.getRTProcContentbyId(id);
      } else {
        throw new Error(this.localePipe.transform("processEditor.wrongMoment"));
      }
    }
  }

  private save(content: string) {
    this.uiState.content = content;
    this.showLoading();
    const process = JSON.parse(this.uiState.content);
    this.saveHttp().subscribe((data) => {
      this.closeLoading();
      // 2023-6-13 保存后同步流程名称到标题栏
      this.procNameTitle = process.DefaultProcess.nameLanguage ? process.DefaultProcess.nameLanguage[localStorage.getItem("languageCode")] : process.DefaultProcess.Name;
      this.notify.success({
        title: this.localePipe.transform("processEditor.prompted"),
        msg: this.localePipe.transform("processEditor.saveSuccess"),
        timeout: 3000
      } as NotifyOptions);
      if (this.time === ProcessTime.dt) {
        this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_SaveDT, true, process.DefaultProcess.Key);
      } else if (this.time === ProcessTime.rt) {
        this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_SaveRT, true, process.DefaultProcess.Key);
      }
      // 重置界面变更状态
      this.changedFlag = false;
    },
      (error: HttpErrorResponse) => {
        this.closeLoading();
        this.notify.error({
          title: this.localePipe.transform("processEditor.prompted"),
          msg: error.error.Message,
          timeout: 3000
        } as NotifyOptions);
        if (this.time === ProcessTime.dt) {
          this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_SaveDT, false, process.DefaultProcess.Key);
        } else if (this.time === ProcessTime.rt) {
          this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_SaveRT, false, process.DefaultProcess.Key);
        }
      });
  }

  private release(content: string) {
    this.uiState.content = content;
    this.showLoading();
    this.uiState.getReleaseConfig().subscribe((config) => {
      if (config.currentValue === 'true') {
        this.viewModel.findReleaseProcessByProcDefKey(this.processInfo.processKey).subscribe(release => {
          const releaseProcList = release.filter(r => r === 1);
          if (releaseProcList.length > 0) {
            this.message.info(this.localePipe.transform('processEditor.releaseCheckPrompt'));
            this.closeLoading();
            return;
          } else {
            // 展示发布前审批页面，同时保存，记审计
            this.viewModel.saveProcess(this.uiState.content, this.processInfo, 1).subscribe((re) => {
            this.viewModel.getProcDefsByKey(JSON.parse(content).DefaultProcess.Key).subscribe((ProcDefs) => {
              const maxVersion = Math.max.apply(Math, ProcDefs.map(function (item) {
                return item.version << 0
              }));
              // 展示发布前审批页面，同时保存，记审计
              this.viewModel.releaseProcess(content, maxVersion === -Infinity ? 1 : maxVersion);
              this.closeLoading();
            });
        });
        this.notify.success({
          title: this.localePipe.transform("processEditor.prompted"),
          msg: this.localePipe.transform("processEditor.waitReview"),
          timeout: 3000
        } as NotifyOptions);
        const process = JSON.parse(this.uiState.content);
        this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_Deploy, true, process.DefaultProcess.Key);
          }
        })
      } else {
        this.viewModel.deployProcess(this.uiState.content).subscribe((data) => {
          this.closeLoading();
          this.viewModel.saveProcess(this.uiState.content, this.processInfo, 0).subscribe((r) => { });
          this.notify.success({
            title: this.localePipe.transform("processEditor.prompted"),
            msg: this.localePipe.transform("processEditor.successPublish"),
            timeout: 3000
          } as NotifyOptions);
          const process = JSON.parse(this.uiState.content);
          this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_Deploy, true, process.DefaultProcess.Key);
        },
          (e: any) => {
            this.closeLoading();
            this.notify.error({
              title: this.localePipe.transform("processEditor.prompted"),
              msg: this.localePipe.transform("processEditor.publishFail") + `${e.error.Message}`,
              timeout: 3000
            } as NotifyOptions);
            const process = JSON.parse(this.uiState.content);
            this.viewModel.auditProcessDef(AuditEvent.WF_ProcessDef_Deploy, false, process.DefaultProcess.Key);
          });
      }
    });
  }

  /**
   * 保存流程定义（设计时+运行时）
   */
  private saveHttp(): Observable<any> {
    if (this.uiState.content) {
      if (this.time === ProcessTime.dt) {
        return this.viewModel.saveProcess(this.uiState.content, this.processInfo, 1);
      } else if (this.time === ProcessTime.rt) {
        return this.viewModel.saveRTProcess(this.uiState.content, this.rtProcessInfo.rtProcDefId);
      } else {
        throw new Error(this.localePipe.transform("processEditor.wrongMoment"));
      }
    }
  }

  showLoading() {
    this.loadService.show({ container: 'body', message: '', type: 1 });
  }
  closeLoading() {
    this.loadService.close();
  }

  private ConvertExecuteForm(form: ExcuteFormEntity): ExecuteFormModel[] {
    const executeForms = new Array();
    if (form.terminal === 'web,app') {
      const webForm = new ExecuteFormModel();
      webForm.ComponentId = form.appId;
      webForm.formFormatId = form.formFormatId;
      webForm.FormType = form.formType;
      webForm.Name = form.name;
      webForm.TerminalType = TerminalType.PC;
      if (form.actualParameters && form.actualParameters.length > 0) {
        webForm.ActualParameters = form.actualParameters.map(p => ({
          Name: p.code,
          Value: p.value
        }));
      }
      executeForms.push(webForm);
      const appForm = new ExecuteFormModel();
      appForm.ComponentId = form.appId;
      appForm.formFormatId = form.formFormatId;
      appForm.FormType = form.formType;
      appForm.Name = form.name;
      appForm.TerminalType = TerminalType.MOBILE;
      if (form.actualParameters && form.actualParameters.length > 0) {
        appForm.ActualParameters = form.actualParameters.map((p: any) => ({
          Name: p.code,
          Tag: p.valueType ? p.valueType : ProcessDeUtil.initVariableType(p.value),
          Value: p.value
        }));
      }
      executeForms.push(appForm);
    } else {
      const executeForm = new ExecuteFormModel();
      executeForm.ComponentId = form.appId;
      executeForm.formFormatId = form.formFormatId;
      executeForm.FormType = form.formType;
      executeForm.Name = form.name;
      switch (form.terminal) {
        case 'web':
          executeForm.TerminalType = TerminalType.PC;
          break;
        case 'app':
          executeForm.TerminalType = TerminalType.MOBILE;
          break;
      }
      if (form.actualParameters && form.actualParameters.length > 0) {
        executeForm.ActualParameters = form.actualParameters.map((p: any) => ({
          Name: p.code,
          Tag: p.valueType ? p.valueType : ProcessDeUtil.initVariableType(p.value),
          Value: p.value
        }));
      }
      executeForms.push(executeForm);
    }
    return executeForms;
  }
  private formFormat2ExecuteForm(formformat): ExecuteFormModel {
    const form = new ExecuteFormModel();
    form.Id = ProcessDeUtil.GenerateElementId();
    form.ComponentId = null;
    form.formFormatId = formformat.id;
    form.FormType = '0';
    form.Name = formformat.name;
    switch (formformat.terminal) {
      case 'PC':
        form.TerminalType = TerminalType.PC;
        break;
      case 'Mobile':
        form.TerminalType = TerminalType.MOBILE;
        break;
    }
    if (formformat.urlParameters && formformat.urlParameters.length > 0) {
      form.ActualParameters = formformat.urlParameters.map(p => ({
        Name: p.code,
        Tag: p.valueType ? p.valueType : ProcessDeUtil.initVariableType(p.value),
        Value: p.value
      }));
    }
    return form;
  }

  private completeStrategyChanged(strategy: string) {

    if (strategy !== this.uiState.completeIterator[0].key) {

      // 参与者存在自动审批的情况下，不允许修改完成策略为会签规则
      // if (this.uiState.propertyData.ParticipantSchemes
      //   && this.uiState.propertyData.ParticipantSchemes.options
      //   && this.uiState.propertyData.ParticipantSchemes.options.automaticPerformers
      //   && this.uiState.propertyData.ParticipantSchemes.options.automaticPerformers.length > 0) {
      //   return;
      // } else {
      // 会签规则不存在，即由抢占模式，变为会签时
      if (!this.uiState.propertyData.SignRule) {
        // 会签是自动弹出会签规则编辑
        const compFactory = this.resolver.resolveComponentFactory(SignRuleComponent);
        const compRef = compFactory.create(this.injector);

        compRef.instance.value = [];
        // compRef.instance.counterSignVariables = this.uiState.counterSignVariables || [];
        // compRef.instance.approvalItems = this.uiState.approvalItems || [];

        const modalConfig: ModalOptions = Object.assign(compRef.instance.modalConfig,
          { buttons: compRef.instance.modalFooter });
        const dialog = this.modalService.show(compRef, modalConfig);
        compRef.instance.closeModal.subscribe($event => dialog.close());
        compRef.instance.submitModal.subscribe((data: any) => {
          this.updateChangeProperty({
            categoryId: 'performerProperty',
            propertyID: UserActivityPropertyKeys.SignRule,
            propertyValue: data.value
          });
          dialog.close();
        });
      }
      // // 会签规则下，驳回规则约束
      // if ((this.uiState.propertyData.BackWardRule as BackWardRule).SelectTargetAble === true) {
      //   setTimeout(() => {
      //     this.message.warning(this.localePipe.transform("processEditor.policyConflict"));
      //   }, 500);
      // }
      // }
    }
  }

  private OtherAssignNodesChanged(data: any) {
    const compFactory = this.resolver.resolveComponentFactory(AssignScopeComponent);
    const compRef = compFactory.create(this.injector);
    let location;
    if (data.Id.indexOf('startActivity') > -1) {
      location = 'startActivity';
    } else {
      location = 'userActivity';
    }
    if (location === 'startActivity') {
      compRef.instance.value = [];
      const activities = this.uiState.userActList.filter(a => a.Id !== this.uiState.propertyData.Id
        && a.AssignmentStrategy === 'ASSIGN'
        && a.AssignPerformerConfig
        && a.AssignPerformerConfig.Operator === 'procInstCreator');
      if (activities && activities.length > 0) {
        compRef.instance.value = activities.map(a => a.Id);
      } else {
        compRef.instance.value = new Array();
      }
    } else {
      compRef.instance.value = [];
    }
    compRef.instance.location = location;
    const modalConfig: ModalOptions = Object.assign(compRef.instance.modalConfig,
      { buttons: compRef.instance.modalFooter });
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModal.subscribe($event => dialog.close());
    compRef.instance.submitModal.subscribe((data: any) => {
      this.updateChangeProperty({
        categoryId: location = 'startActivity' ? 'activityConfig' : 'approvalProperty',
        // todo：多个活动具有同名属性时，如何更合理定义PropertyKey？
        propertyID: UserActivityPropertyKeys.otherAssignActivities,
        propertyValue: data.value
      });
      dialog.close();
    });
  }

  /**
   * 完成策略调整校验
   */
  private beforeCompleteStrategyChange(data: any): Observable<boolean> {
    if(data.propertyValue !== this.uiState.completeIterator[0].key){
      // 会签规则下，驳回规则约束
      if ((this.uiState.propertyData.BackWardRule as BackWardRule).SelectTargetAble === true) {
        setTimeout(() => {
          this.message.warning(this.localePipe.transform("processEditor.policyConflict"));
        }, 500);
        return of(false);
      }
    }
    if (this.time === ProcessTime.rt) {
      return this.viewModel.beforeCompleteStrategyChange(data, this.rtProcessInfo);
    } else {
      return of(true);
    }
  }


  /**
   * 保存，发布，另存，同步操作时
   * 校验模型的流程分类ID与列表存储是否一致，不一致时，以列表为准
   */
  private checkModelContent(content: string): string {
    const process = JSON.parse(content);
    const modelBizDefKey = process.DefaultProcess.extensionElements.find(e => e.ClrTypeID === 'wf.ProcessHeader').BizDefKey;
    if (this.time === ProcessTime.dt) {
      if (modelBizDefKey === this.processInfo.flowFormId) {
        return content;
      } else {
        process.DefaultProcess.extensionElements.find(e => e.ClrTypeID === 'wf.ProcessHeader').BizDefKey = this.processInfo.flowFormId;
        process.DefaultProcess.extensionElements.find(e => e.ClrTypeID === 'wf.ProcessHeader').BizDefName = this.uiState.flowFormInfo.flowForm.name;
        return JSON.stringify(process);
      }
    } else if (this.time === ProcessTime.rt) {
      if (modelBizDefKey === this.rtProcessInfo.flowFormId) {
        return content;
      } else {
        process.DefaultProcess.extensionElements.find(e => e.ClrTypeID === 'wf.ProcessHeader').BizDefKey = this.rtProcessInfo.flowFormId;
        process.DefaultProcess.extensionElements.find(e => e.ClrTypeID === 'wf.ProcessHeader').BizDefName = this.uiState.flowFormInfo.flowForm.name;
        return JSON.stringify(process);
      }
    }
  }

  public showModeChange(event: any) {
    const { mode = ShowMode.panel, wideWidth = 330, smallWidth = 41 } = event || {};
    if (mode === ShowMode.panel) {
      this.panelWidth = wideWidth;
      this.rightPanelWidth = wideWidth;
    } else if (mode === ShowMode.sidebar) {
      this.panelWidth = smallWidth;
      this.rightPanelWidth = smallWidth;
    }
  }

  saveProc() {
    const model = this.editorUi.graph.bpmnModel;
    const res = WfValidatorAdapter.validator(model, this.scene);
    if (res.valid == false) {
      this.showTip(res);
      return;
    }
    if (res.warningList && res.warningList.length > 0) {
      this.showVerify(res.warningList);
    } else {
      this.clearValidationTips();
    }
    if(this.oldBizDefKey) {
      this.viewModel.checkExpressions(model.ConvertToJson(), this.processInfo, this.oldBizDefKey, true).subscribe(re => {
        if(re && re.result) {
          this.save(model.ConvertToJson());
        }
      });
    }else {
      this.save(model.ConvertToJson());
    }
  }
  saveAs() {
    if (!(this.uiState.enableAdminOrgAut || ((this.uiState.isAdministratorConfig &&
      this.uiState.administrator !== null) || (!this.uiState.isAdministratorConfig)))) {
      this.message.info(this.localePipe.transform("processEditor.noPermissionToSave"));
      return;
    }
    const model = this.editorUi.graph.bpmnModel;
    const res = WfValidatorAdapter.validator(model, this.scene);
    if (res.valid == false) {
      this.showTip(res);
      return;
    }
    if (res.warningList && res.warningList.length > 0) {
      this.showVerify(res.warningList);
    } else {
      this.clearValidationTips();
    }
    const process = new BpmnModel();
    process.LoadFromJson(model.ConvertToJson());
    // process.DefaultProcess.Key = ProcessDeUtil.GenerateElementId();
    // process.DefaultProcess.Id = ProcessDeUtil.GenerateElementId();
    // process.DefaultDiagram.BpmnPlane.BpmnElementId = process.DefaultProcess.Id;
    // this.viewModel.saveAsProcess(process, this.processInfo);
    this.saveAsProcess(process, this.processInfo);

  }

  saveAsProcess(process: BpmnModel, processInfo: ProcessInfo) {
    const compFactory = this.resolver.resolveComponentFactory(SaveAsEditComponent);
    const compRef = compFactory.create(this.injector);
    const processJson = new BpmnModel(); 
    processJson.LoadFromJson(process.ConvertToJson())
    const bizDefKey = (processJson.DefaultProcess.GetExtensionElements().find(e => e.ClrTypeID === 'wf.ProcessHeader') as ProcessHeader).BizDefKey;
    const newProcKey = ProcessDeUtil.GenerateElementId();
    const newProcId = ProcessDeUtil.GenerateElementId();
    compRef.instance.procKey = newProcKey;
    compRef.instance.procName = process.DefaultProcess.NameLanguage ? (process.DefaultProcess.NameLanguage[this.localePipe.langCode] ? process.DefaultProcess.NameLanguage[this.localePipe.langCode] + this.localePipe.transform('app.processDesigner.copy') : process.DefaultProcess.Name + this.localePipe.transform('app.processDesigner.copy')) : process.DefaultProcess.Name + this.localePipe.transform('app.processDesigner.copy');
    compRef.instance.isAdministratorConfig = this.uiState.isAdministratorConfig;
    compRef.instance.enableAdminOrgAut = this.uiState.enableAdminOrgAut;
    compRef.instance.administrator = this.uiState.administrator;
    compRef.instance.accessLevel = processInfo.accessLevel;
    if (!this.uiState.enableAdminOrgAut && !this.uiState.isAdministratorConfig) {
      compRef.instance.organization = processInfo.procOrg.orgId;
      compRef.instance.organizationName = processInfo.procOrg.orgName;
    }
    const modalOptions = {
      title: this.localePipe.transform('app.processDesigner.saveAs'),
      width: 450, height: 460,
      buttons: compRef.instance.btnRef,
      showButtons: true
    };
    const dlg = this.modalService.show(compRef, modalOptions);
    compRef.instance.submit.subscribe((re: any) => {
      // process.DefaultProcess.Name = re.procName;
      const procInfo = new ProcessInfo();
      procInfo.accessLevel = re.accessLevel;
      procInfo.procOrg = {
        orgId: re.organization,
        orgName: re.organizationName
      };
      let newBizDefId;
      let newBizCategoryId;
      if(re.bizDef) {
        newBizDefId = re.bizDef.id;
        newBizCategoryId = re.bizDef.businessObjectId;
      }
      this.service.saveAsProcess(process.ConvertToJson(), newBizDefId, newProcKey, re.procName, newProcId).subscribe(r => {
        if(r) {
          const newProcess = new BpmnModel();
          newProcess.LoadFromJson(JSON.stringify(r));
          const info = {
            oldTime: this.time,
            oldAction: this.action,
            oldSecne: this.scene,
            oldProcType: this.procType,
            oldContent: this.editorUi.graph.bpmnModel,
            oldChangedFlag: this.changedFlag,
            oldProcInfo: this.processInfo,
            oldBizCategoryId: this.editorUi.bizCategoryId,
            newBizCategoryId: newBizCategoryId,
            newProcess: newProcess,
            procInfo: procInfo,
            oldBizDefKey: bizDefKey,
            action: 'edit',
            scene: this.scene,
            procType: this.procType
          };
          document.body.removeEventListener('keydown', this.keydownHandler);
          this.outProc.emit(info);
        }
      }, err => {
        this.notify.error({
          title: this.localePipe.transform('app.processDesigner.tips'), msg: this.localePipe.transform('app.processDesigner.saveAsFail'), timeout: 3000
        } as NotifyOptions);
      });
      dlg.close();
    });
    compRef.instance.cancel.subscribe(r => {
      dlg.close();
    });
  }



  releaseProc() {
    const model = this.editorUi.graph.bpmnModel;
    const res = WfValidatorAdapter.validator(model, this.scene);
    if (res.valid == false) {
      this.showTip(res);
      return;
    }
    if (res.warningList && res.warningList.length > 0) {
      this.showVerify(res.warningList);
    } else {
      this.clearValidationTips();
    }
    if(this.oldBizDefKey) {
      this.viewModel.checkExpressions(model.ConvertToJson(), this.processInfo, this.oldBizDefKey, false).subscribe(re => {
        if(re) {
          this.release(model.ConvertToJson());
        }
      });
    } else {
      this.release(model.ConvertToJson());
    }
  }
  sync() {
    const model = this.editorUi.graph.bpmnModel;
    const res = WfValidatorAdapter.validator(model, this.scene);
    if (res.valid == false) {
      this.showTip(res);
      return;
    }
    if (res.warningList && res.warningList.length > 0) {
      this.showVerify(res.warningList);
    } else {
      this.clearValidationTips();
    }
    this.viewModel.syncDtProcess(model.ConvertToJson(), this.rtProcessInfo);
  }
  procRecord() {
    const record = this.editorUi.graph.bpmnModel.DefaultProcess.Documentation;
    this.note(record);
  }
  batchSet() {
    const compFactory = this.resolver.resolveComponentFactory(BatchSetPropertiesComponent);
    const compRef = compFactory.create(this.injector);
    const modalConfig: ModalOptions = {
      title: '批量设置',
      width: 512,
      height: 565,
      showButtons: true,
      buttons: compRef.instance.footer
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.cancel.subscribe($event => dialog.close());
    compRef.instance.submit.subscribe((data: string) => {
      dialog.close();
    });
  }
  closeProc() {
    if(!this.isShowCloseDialog) {
      this.isShowCloseDialog = true;
      // 如果是另存为后的界面，增加确认框提示，直接关闭需要提示
      if(this.uiState.isByRoute && this.changedFlag) {
        this.message.confirm(this.localePipe.transform("processEditor.closeProc1"),
          this.localePipe.transform("processEditor.closeProc3")).subscribe(
            (f) => {
              if (f) {
                document.body.removeEventListener('keydown', this.keydownHandler);
                if(this.uiState.msg) {
                  this.uiState.msg.close();
                }
                this.close.emit();
              }else {
                this.isShowCloseDialog = false;
              }
            }
          );
      }
      // 如果界面发生变化，增加确认框提示，无变化则直接关闭
      else if (this.changedFlag) {
        this.message.confirm(this.localePipe.transform("processEditor.closeProc1"),
          this.localePipe.transform("processEditor.closeProc2")).subscribe(
            (f) => {
              if (f) {
                document.body.removeEventListener('keydown', this.keydownHandler);
                this.close.emit();
              }else {
                this.isShowCloseDialog = false;
              }
            }
          );
      } else {
        document.body.removeEventListener('keydown', this.keydownHandler);
        this.close.emit();
      }
    }
  }
  viewProcModel() {
    // 模型自动复制到剪贴板
    this.notify.success(this.localePipe.transform("processEditor.copied"));
    this.copy(this.editorUi.graph.bpmnModel.ConvertToJson());

    const cmpF = this.resolver.resolveComponentFactory(MonacoEditorComponent);
    const cmpR = cmpF.create(this.injector, []);

    cmpR.instance.options = {
      theme: 'vs-dark',
      language: 'json',
      readOnly: false,
    };

    cmpR.instance.model = {
      value: this.editorUi.graph.bpmnModel.ConvertToJson(),
      language: 'json',
    };

    cmpR.instance.onInit.subscribe(
      () => {
        setTimeout(() => {
          cmpR.instance.formatDocument();
        }, 300);
      }
    );

    const modalConfig: ModalOptions = {
      title: this.localePipe.transform("processEditor.viewModel"),
      width: 800,
      height: 520,
      showButtons: false,
    };
    const modalRef = this.modalService.show(cmpR, modalConfig);
    modalRef.dialog.instance.maxDialog();

    modalRef.dialog.instance.resized.subscribe((evt) => {
      // 重置内容刷新代码编辑器
      cmpR.instance.model = {
        value: this.editorUi.graph.bpmnModel.ConvertToJson(),
        language: 'json',
      };
    });
  }
  /**
   * 左右拖动后事件，event.size.width是左侧面板的宽度
   */
  rzStop(event) {
    this.panelWidth = event.size.width;

    this.editorUi && this.editorUi.graph.refresh();
  }

  // 展示表单验证组件，用于构件校验
  createValidationTips() {
    this.verifySer.clear();
    this.verifyContainer = this.verifySer.createVerify({
      parent: this.contentEl,
      verifyList: this.errorList,
      verifyType: this.tabTypeList,
      showList: true,
      showType: 'processWarning',
      verifyResultTipsTmpl: this.tipsTmpl // 提示模板
    });
    this.listclick = this.verifyContainer.validatorClick.subscribe(e => {
      console.log(e);
    });
    this.showchange = this.verifyContainer.listshowChange.subscribe(e => {
      console.log(e);
    });
  }

  public clearValidationTips() {
    this.errorList = [];
    if (this.verifySer) {
      this.verifySer.clear();
    }
  }

  copy(text) {
    const el = document.createElement('input')
    el.setAttribute('value', text)
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
  }

  viewModelMethod(n) {
    if (!this.showModelButton && n.shiftKey && 'Slash' === n.code) {
      this.showModelButton = true;
      this.notify.success(this.localePipe.transform("processEditor.showButton"));
      this.viewProcModel();
    }
  }

  openTitleExpression(value, schemas) :Observable<any> {
    let subject = new Subject<any>();
    const compFactory = this.resolver.resolveComponentFactory(TitleExpressionComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.value = value;
    this.uiState.schemas = schemas;
    compRef.instance.editorParams = {
      location : 'process',
    };
    let option = new ModalOptions();
    option.title = compRef.instance.modalConfig.title;
    option.width = compRef.instance.modalConfig.width;
    option.height = compRef.instance.modalConfig.height;
    option.showButtons = compRef.instance.modalConfig.showButtons;
    option.buttons = compRef.instance.modalFooter;
    const editDialog = this.modalService.show(compRef, option);
    compRef.instance.submitModal.subscribe(titleExpression => {
      subject.next(titleExpression);
      editDialog.close();
    });
    compRef.instance.closeModal.subscribe(re => {
      subject.next(re);
      editDialog.close();
    });
    return subject.asObservable();
  }

  openExecuteForm(tab, value, flowformInfo, schemas):Observable<any> {
    let subject = new Subject<any>();
    this.uiState.flowFormInfo = flowformInfo;
    this.uiState.schemas = schemas;
    const compFactory = this.resolver.resolveComponentFactory(ExecuteFormsComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.value = value;
    compRef.instance.editorParams = {
      location : 'process',
      tab : tab
    };
    let option = new ModalOptions();
    option.title = compRef.instance.modalConfig.title;
    option.width = compRef.instance.modalConfig.width;
    option.height = compRef.instance.modalConfig.height;
    option.showButtons = compRef.instance.modalConfig.showButtons;
    option.buttons = compRef.instance.modalFooter;
    const editDialog = this.modalService.show(compRef, option);

    compRef.instance.submitModal.subscribe(cmp => {
      let data = new ExecuteFormModel();
      compRef.instance.getForm().subscribe((re: any) => {
        if (!re.result) {
          return;
        }
        data = re.form;
        if (this.validatorExecuteForm(data, compRef.instance.allParameters)) {
          let parameters = null;
          // 如果存在变量类型参数在流程变量上不存在，需要同步流程变量
          if (data && data.ActualParameters && data.ActualParameters.length > 0) {
            const formalParameters = this.uiState.flowFormInfo.formalParameters.filter(p => p.dataType !== 'CDTSchema');
            for (const parameter of data.ActualParameters) {
              if (parameter.Tag ==='variable' && parameter.Value && !compRef.instance.allParameters.some(p => p.key === parameter.Value) && formalParameters.some(p => p.code === parameter.Value)) {
                parameters = formalParameters;
                break;
              }
            }
          }
          const object = { value: data, parameters };
          subject.next(object);
        }
      });
      editDialog.close();
    });
    compRef.instance.closeModal.subscribe(re => {
      subject.next(re);
      editDialog.close();
    });
    return subject.asObservable();
  }

  validatorExecuteForm(form: ExecuteFormModel, allParameters) {
    if (form && form.ActualParameters && form.ActualParameters.length > 0) {
      const formalParameters = this.uiState.flowFormInfo.formalParameters.filter(p => p.dataType !== 'CDTSchema');
      for (const parameter of form.ActualParameters) {
        if (parameter.Tag ==='variable' && parameter.Value && !allParameters.some(p => p.key === parameter.Value) && !formalParameters.some(p => p.code === parameter.Value)) {
          this.message.error(this.localePipe.transform('component.executeForms.parameters') + parameter.Name + this.localePipe.transform('component.executeForms.typeAsvariable'));
          return false;
        }
      }
    }
    return true;
  }

  openProcComponent(showParameters:boolean, isEdit: boolean, executionTimingList, curComponent?):Observable<any> {
    let subject = new Subject<any>();
    const compFactory = this.resolver.resolveComponentFactory(EditComponentParameterComponent);
    const compRef = compFactory.create(this.injector);
    let option = new ModalOptions();
    if(!isEdit) {
      option.title = this.localePipe.transform('component.activityComponent.selectComponent');
    }else {
      option.title = this.localePipe.transform('component.activityComponent.editComponent');
    }
    option.width = 700;
    option.height = 400;
    option.showButtons = true;
    option.buttons = compRef.instance.editFooter;
    if(isEdit) {
      option.initialState = {
        curComponent: JSON.parse(JSON.stringify(curComponent))
      }
    }
    const editDialog = this.modalService.show(compRef, option);
    if(!isEdit) {
      compRef.instance.canEdit = true;
      compRef.instance.editState = 'new';
      compRef.instance.location = 'process';
      compRef.instance.executionTimingList = executionTimingList;
      compRef.instance.curComponent = new BizComponentEntity();
      if(!showParameters) {
        compRef.instance.isShowParameters = false;
      }
    }else {
      compRef.instance.canEdit = false;
      compRef.instance.editState = 'edit';
      compRef.instance.location = 'process';
      compRef.instance.executionTimingList = executionTimingList;
      if(!showParameters) {
        compRef.instance.isShowParameters = false;
      }
    }
    compRef.instance.submitEmitter.subscribe(cmp => {
      subject.next(cmp);
      editDialog.close();
    });
    compRef.instance.closeEmitter.subscribe(re => {
      subject.next(re);
      editDialog.close();
    });
    setTimeout(() => {
      compRef.instance.cd.detectChanges();
    })
    return subject.asObservable();
  }

  openTimeLimitControl(value, flowformInfo, schemas):Observable<any> {
    let subject = new Subject<any>();
    this.uiState.flowFormInfo = flowformInfo;
    this.uiState.schemas = schemas;
    const compFactory = this.resolver.resolveComponentFactory(TimeLimitControlComponent);
    const compRef = compFactory.create(this.injector);
    let option = new ModalOptions();
    option.title = compRef.instance.modalConfig.title;
    option.width = compRef.instance.modalConfig.width;
    option.height = compRef.instance.modalConfig.height;
    option.showButtons = compRef.instance.modalConfig.showButtons;
    option.buttons = compRef.instance.modalFooter;
    compRef.instance.value = value;
    compRef.instance.editorParams = {
      location : 'process',
    }
    const editDialog = this.modalService.show(compRef, option);
    compRef.instance.submitModal.subscribe(dueTime => {
      subject.next(dueTime);
      editDialog.close();
    });
    compRef.instance.closeModal.subscribe(re => {
      subject.next(re);
      editDialog.close();
    });
    return subject.asObservable();
  }

}
